// extracted by mini-css-extract-plugin
module.exports = {"card":"mS","onlyImage":"nS"};